<template>
  <div class="account-page">
    <div class="main-wrapper">
      <div class="account-content">
        <form @submit.prevent="submitForm" class="flex-fill">
          <div class="mx-auto mw-450">
            <div class="text-center mb-4">
              <img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo" />
            </div>
            <div class="mb-4">
              <h4 class="mb-2 fs-20">Forgot Password?</h4>
              <p>
                If you forgot your password, well, then we’ll email you
                instructions to reset your password.
              </p>
            </div>
            <div class="mb-3">
              <label class="col-form-label">Email Address</label>
              <div class="position-relative">
                <span class="input-icon-addon">
                  <i class="ti ti-mail"></i>
                </span>
                <input type="text" v-model="form.email" class="form-control" />
              </div>
              <div class="emailshow text-danger" v-if="errorData.errors.email">
                {{ errorData.errors.email[0] }}
              </div>
            </div>
            <div class="mb-3">
              <button
                type="submit"
                class="btn btn-primary w-100"
                :disabled="isLoading"
              >
                <span v-if="isLoading">
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Submitting...
                </span>
                <span v-else> Submit </span>
              </button>
            </div>
            <div class="mb-3 text-center">
              <h6>
                Return to
                <router-link to="/" class="text-purple link-hover">
                  Login</router-link
                >
              </h6>
            </div>
            <div class="form-set-login or-text mb-3">
              <h4>OR</h4>
            </div>
            <div
              class="d-flex align-items-center justify-content-center flex-wrap mb-3"
            >
              <div class="text-center me-2 flex-fill">
                <a
                  href="javascript:void(0);"
                  class="br-10 p-2 px-4 btn bg-pending d-flex align-items-center justify-content-center"
                >
                  <img
                    class="img-fluid m-1"
                    src="@/assets/img/icons/facebook-logo.svg"
                    alt="Facebook"
                  />
                </a>
              </div>
              <div class="text-center me-2 flex-fill">
                <a
                  href="javascript:void(0);"
                  class="br-10 p-2 px-4 btn bg-white d-flex align-items-center justify-content-center"
                >
                  <img
                    class="img-fluid m-1"
                    src="@/assets/img/icons/google-logo.svg"
                    alt="Facebook"
                  />
                </a>
              </div>
              <div class="text-center flex-fill">
                <a
                  href="javascript:void(0);"
                  class="bg-dark br-10 p-2 px-4 btn btn-dark d-flex align-items-center justify-content-center"
                >
                  <img
                    class="img-fluid m-1"
                    src="@/assets/img/icons/apple-logo.svg"
                    alt="Apple"
                  />
                </a>
              </div>
            </div>
            <div class="text-center">
              <p class="fw-medium text-gray">Copyright &copy; 2024 - CRMS</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref } from "vue";
import { RouterLink, useRouter } from "vue-router";
import http from "@/utils/http";

const router = useRouter();

const form = reactive({
  email: "",
});

const isLoading = ref(false);

const errorData = reactive({
  errors: {},
});

const submitForm = async () => {
  isLoading.value = true;
  errorData.errors = {};

  try {
    const response = await http.post("/forgot-password", {
      email: form.email,
    });

    if (response.status === 200) {
      localStorage.setItem("email", form.email);
      router.push("/reset-password");
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.errors) {
      errorData.errors = error.response.data.errors;
    } else {
      console.error("An unexpected error occurred.");
    }
  } finally {
    isLoading.value = false;
  }
};
</script>
